import { apiClient } from './api';
import type {
  MatchHistoryDetail,
  MatchHistoryPage,
  RatingVerificationAction,
  RatingVerificationReason,
} from '../types';

export interface MatchHistoryPageRequest {
  limit?: number;
  cursor?: string | null;
  signal?: AbortSignal;
}

function pageParams(request: MatchHistoryPageRequest) {
  return {
    limit: request.limit ?? 30,
    ...(request.cursor ? { cursor: request.cursor } : {}),
  };
}

export async function getMyMatchHistory(request: MatchHistoryPageRequest = {}): Promise<MatchHistoryPage> {
  const response = await apiClient.get<MatchHistoryPage>('/api/v1/web/matches/history', {
    params: pageParams(request),
    signal: request.signal,
  });
  return response.data;
}

export async function getSquadMatchHistory(
  squadId: number | string,
  request: MatchHistoryPageRequest = {}
): Promise<MatchHistoryPage> {
  const response = await apiClient.get<MatchHistoryPage>(`/api/v1/web/matches/squads/${squadId}/history`, {
    params: pageParams(request),
    signal: request.signal,
  });
  return response.data;
}

export async function getMatchHistoryDetail(matchId: string, signal?: AbortSignal): Promise<MatchHistoryDetail> {
  const response = await apiClient.get<MatchHistoryDetail>(
    `/api/v1/web/matches/history/${encodeURIComponent(matchId)}`,
    { signal }
  );
  return response.data;
}

export async function commandRatingVerification(
  resultVersionId: string,
  command: {
    clientCommandId: string;
    action: RatingVerificationAction;
    reasonCode?: RatingVerificationReason;
  }
): Promise<void> {
  await apiClient.post(
    `/api/v1/web/ratings/evidence/results/${encodeURIComponent(resultVersionId)}/confirmation`,
    command
  );
}
